export * from './SVGParser';
